/** Get how the data was stored
 * @param multiFile - whether there are multiple spectra (subfiles) or not.
 * @param xy - uneven x values
 * @param xyxy - multifile with separate x axis
 * @return the shape of the data as a string
 */
export function getDataShape({ multiFile, xy, xyxy, }) {
    /* single file */
    if (!multiFile) {
        // Y or XY,
        return !xy ? 'Y' : xyxy ? 'exception' : 'XY';
    }
    /* then multifile */
    if (!xy) {
        /* even X - equidistant */
        return 'YY';
    }
    else {
        // uneven x
        return !xyxy ? 'XYY' : 'XYXY';
    }
}
//# sourceMappingURL=getDataShape.js.map